import {
  AML_CHECK,
  AML_CHECK_V2,
  BETWEEN,
  EQUALS,
  GT,
  GTE,
  IN,
  IN_CASE_INSENSITIVE,
  LAST_YEAR,
  LT,
  LTE,
  NOT_EQUALS,
  EXISTS,
  NOT_IN,
  FUZZY_MATCH_SCORE_LT,
  IDV_CHECK,
  COMPANY_SANCTIONS_CATEGORIES,
  UBO_MISMATCH,
  BANK_ACCOUNT_VERIFICATION,
} from './index';

import { OPERATION } from './enums';

export const OperationHelpers = {
  [OPERATION.EQUALS]: EQUALS,
  [OPERATION.NOT_EQUALS]: NOT_EQUALS,
  [OPERATION.EXISTS]: EXISTS,
  [OPERATION.BETWEEN]: BETWEEN,
  [OPERATION.GT]: GT,
  [OPERATION.GTE]: GTE,
  [OPERATION.LT]: LT,
  [OPERATION.LTE]: LTE,
  [OPERATION.LAST_YEAR]: LAST_YEAR,
  [OPERATION.IN]: IN,
  [OPERATION.IN_CASE_INSENSITIVE]: IN_CASE_INSENSITIVE,
  [OPERATION.NOT_IN]: NOT_IN,
  [OPERATION.AML_CHECK]: AML_CHECK,
  [OPERATION.AML_CHECK_V2]: AML_CHECK_V2,
  [OPERATION.BANK_ACCOUNT_VERIFICATION]: BANK_ACCOUNT_VERIFICATION,
  [OPERATION.FUZZY_MATCH_SCORE_LT]: FUZZY_MATCH_SCORE_LT,
  [OPERATION.IDV_CHECK]: IDV_CHECK,
  [OPERATION.COMPANY_SANCTIONS_CATEGORIES]: COMPANY_SANCTIONS_CATEGORIES,
  [OPERATION.UBO_MISMATCH]: UBO_MISMATCH,
} as const;

export const OPERATORS_WITHOUT_PATH_COMPARISON = [
  OPERATION.AML_CHECK,
  OPERATION.AML_CHECK_V2,
  OPERATION.BETWEEN,
  OPERATION.LAST_YEAR,
  OPERATION.UBO_MISMATCH,
  OPERATION.BANK_ACCOUNT_VERIFICATION,
] as const;

export const OPERATORS_WITH_THRESHOLD = [OPERATION.FUZZY_MATCH_SCORE_LT] as const;
